import { SESSION } from "src/session.config";

const BLOCKED_PREFIXES = ["/login", "/error", "/404"];

export function isSafeReturnUrl(url: string | null | undefined): url is string {
	if (!url || typeof url !== "string") {
		return false;
	}

	const trimmed = url.trim();
	if (!trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.includes("://")) {
		return false;
	}

	const path = trimmed.split("?")[0].split("#")[0];
	return !BLOCKED_PREFIXES.some(
		(blocked) => path === blocked || path.startsWith(`${blocked}/`),
	);
}

export function setReturnUrl(url: string): void {
	if (!isSafeReturnUrl(url)) {
		return;
	}
	sessionStorage.setItem(SESSION.SESSION_KEY_RETURN_URL, url);
}

export function peekReturnUrl(): string | null {
	const url = sessionStorage.getItem(SESSION.SESSION_KEY_RETURN_URL);
	return isSafeReturnUrl(url) ? url : null;
}

export function consumeReturnUrl(): string | null {
	const url = peekReturnUrl();
	if (url) {
		sessionStorage.removeItem(SESSION.SESSION_KEY_RETURN_URL);
	}
	return url;
}
